import type { UpdateRolePermissionsDTO } from "@src/domain/dto/rolePermissions";
import type {
  IRolePermissionsRepository,
  UpdateRolePermissionsResult,
} from "@src/domain/repositories/rolePermissions";

export class UpdateRolePermissionsUseCase {
  private readonly rolePermissionsRepository: IRolePermissionsRepository;

  constructor(rolePermissionsRepository: IRolePermissionsRepository) {
    this.rolePermissionsRepository = rolePermissionsRepository;
  }

  async execute(
    params: UpdateRolePermissionsDTO,
  ): Promise<UpdateRolePermissionsResult> {
    try {
      const updated =
        await this.rolePermissionsRepository.updateRolePermissions(params);
      if (!updated) {
        throw new Error("No role permissions returned");
      }
      return updated;
    } catch (error) {
      console.error("Failed to update role permissions:", error);
      throw new Error("Failed to update role permissions");
    }
  }
}
